import React, { useRef, useState, useMemo, useEffect } from 'react';
import { useAuth } from '../../hooks/AuthProvider';
import JoditEditor from 'jodit-react';
import { Box, Flex } from 'reflexbox';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const EditArticle = ({ placeholder }) => {
    const { t } = useTranslation('common');
    const { id } = useParams();
    const editor = useRef(null);
    const config = useMemo(() => ({
        readonly: false,
        placeholder: placeholder || t('admin.editorPlaceholder')
    }), [placeholder]);

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const auth = useAuth();

    useEffect(() => {
        // axios.get(`http://127.0.0.1:8000/article/${id}`)
        //     .then(res => {
        //         console.log(res);
        //         setTitle(res.data.title);
        //         setDescription(res.data.description);
        //     })
        //     .catch(error => {
        //         console.error('Error fetching article:', error);
        //     });
    }, [id]);

    return (
        <Box 
            width="100%" 
            paddingTop="40px" 
            paddingLeft="40px" 
            paddingRight="40px"
        >
            <Flex flexDirection="column">
                <h1>{t('admin.editArticleTitle')}</h1>
                <Flex flexDirection="row">
                    <button 
                        type="submit" 
                        className="w-60 
                            text-white 
                            bg-primary-600 
                            hover:bg-primary-700 
                            focus:ring-4 
                            focus:outline-none 
                            focus:ring-primary-300 
                            font-medium 
                            rounded-lg 
                            text-sm 
                            px-5 
                            py-2.5 
                            text-center 
                            dark:bg-primary-600 
                            dark:hover:bg-primary-700 
                            dark:focus:ring-primary-800"
                        onClick={() => {
                            window.location.href = "/admin";
                        }}
                    >
                        {t('admin.back')}
                    </button>
                    <Box marginLeft="20px">
                        <button 
                            type="submit" 
                            className="w-60 
                                text-white 
                                bg-primary-600 
                                hover:bg-primary-700 
                                focus:ring-4 
                                focus:outline-none 
                                focus:ring-primary-300 
                                font-medium 
                                rounded-lg 
                                text-sm 
                                px-5 
                                py-2.5 
                                text-center 
                                dark:bg-primary-600 
                                dark:hover:bg-primary-700 
                                dark:focus:ring-primary-800"
                            onClick={() => auth.logOut()}
                        >
                            {t('admin.logout')}
                        </button>
                    </Box>
                </Flex>
            </Flex>
            <div>
                <Box marginTop="20px" marginBottom="20px">
                    <input 
                        type="text" 
                        placeholder={t('admin.titlePlaceholder')} 
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        className="w-60"
                    />
                </Box>
                <JoditEditor
                    ref={editor}
                    value={description}
                    config={config}
                    tabIndex={1}
                    onChange={newDescription => {
                        setDescription(newDescription);
                    }}
                />
            </div>
            <Box marginTop="20px">
                <button 
                    type="submit" 
                    className="w-60 
                        text-white 
                        bg-primary-600 
                        hover:bg-primary-700 
                        focus:ring-4 
                        focus:outline-none 
                        focus:ring-primary-300 
                        font-medium 
                        rounded-lg 
                        text-sm 
                        px-5 
                        py-2.5 
                        text-center 
                        dark:bg-primary-600 
                        dark:hover:bg-primary-700 
                        dark:focus:ring-primary-800"
                    onClick={() => {
                        // axios.put(`http://127.0.0.1:8000/article/${id}`, null, {
                        //     params: {
                        //         title: title,
                        //         description: description,
                        //     }
                        // })
                        // .then(res => {
                        //     console.log(res);
                        //     window.location.href = "/admin";
                        // })
                        // .catch(error => {
                        //     console.error('Error updating article:', error);
                        // });
                    }}
                >
                    {t('admin.update')}
                </button>
            </Box>
        </Box>
    );
}
